import gql from 'graphql-tag';
import { useQuery } from '@apollo/react-hooks';

import { useCurrentAccountId } from '@zapier/design-system-revenue/src/hooks';
import { TrialType } from '@zapier/design-system-revenue/src/types';

import { currentAccount as CurrentAccountData } from './types/currentAccount';

export const currentAccountQuery = gql`
  query currentAccount($accountId: Int!) {
    account(id: $accountId) {
      id
      enabledTrialExtensions
      isTrialing
      isTrialingTeams
      isTrialingCompanies
      plan: planV2 {
        amount
        hasMeteredBilling
        id
        interval
        name
        type
      }
      usage {
        tasks {
          total
          limit
        }
      }
    }
  }
`;

export const useCurrentAccount = () => {
  const { accountId } = useCurrentAccountId();

  const { data, error, loading } = useQuery<CurrentAccountData>(
    currentAccountQuery,
    {
      skip: !accountId,
      variables: {
        accountId,
      },
    }
  );

  const account = data?.account;

  return {
    activeTrialType: account?.isTrialingCompanies
      ? ('Company' as TrialType)
      : account?.isTrialingTeams
      ? ('Team' as TrialType)
      : account?.isTrialing
      ? ('Professional' as TrialType)
      : null,
    currentPlan: account?.plan,
    enabledTrialExtensions: account?.enabledTrialExtensions ?? [],
    error: error
      ? 'There was an error fetching account information. Please try again.'
      : null,
    isLoading: loading,
  };
};
